<template>
  <v-container fluid class="pa-0 ma-0">
    <!-- <Carousel /> -->
    <Header />
    <!-- <Header_2 class="mt-4" /> -->
    <!-- <ScrollDownBtn class="mt-12" /> -->
    <v-row>
      <UnderLinedHeader
        class="white mt-4"
        :class="!$vuetify.breakpoint.smAndDown ? 'px-16' : 'px-2'"
      >
        Complete, Knowledge-Driven Solutions
        <br />
        to Help Your Practice Thrive
      </UnderLinedHeader>
    </v-row>
    <v-row justify="center" align="center" class="mt-8"  :class="!$vuetify.breakpoint.smAndDown ? 'px-12' : 'px-4'">
      <p class="artice-text text-center " 
      :class="!$vuetify.breakpoint.mdAndDown ? 'px-16' : 'px-8'"
      >
        3545 Consulting – Global provides comprehensive, technology solutions,
        tailored to empower law firms to work smarter and more efficiently. Our
        dedicated team of experts get to know each client and their personnel,
        to gain a thorough understanding of how their law firm operates. We
        listen to your needs and ask the necessary questions to find customized
        solutions within your budget that will improve processes and help you
        effectively run your business.
      </p>
    </v-row>
     <!-- <techSteps /> -->
    <Services/>

   
    <!-- <products /> -->
    <Endorsements />
    <!-- <SupportedProducts /> -->
    <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
      <path
        fill="#a81e2d"
        fill-opacity="1"
        d="M0,128L24,149.3C48,171,96,213,144,240C192,267,240,277,288,256C336,235,384,181,432,170.7C480,160,528,192,576,224C624,256,672,288,720,288C768,288,816,256,864,240C912,224,960,224,1008,224C1056,224,1104,224,1152,202.7C1200,181,1248,139,1296,133.3C1344,128,1392,160,1416,176L1440,192L1440,320L1416,320C1392,320,1344,320,1296,320C1248,320,1200,320,1152,320C1104,320,1056,320,1008,320C960,320,912,320,864,320C816,320,768,320,720,320C672,320,624,320,576,320C528,320,480,320,432,320C384,320,336,320,288,320C240,320,192,320,144,320C96,320,48,320,24,320L0,320Z"
      ></path>
    </svg> -->
  </v-container>
</template>

<script>
import ScrollDownBtn from "@/components/landing/ScrollDownBtn.vue";
import techSteps from "@/components/landing/techSteps.vue";
import Products from "@/components/landing/Products.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
//import Carousel from "@/components/landing/Carousel.vue";
import Header from "@/components/landing/Header.vue";
import Services from "@/components/landing/Services.vue";
import Header_2 from "@/components/landing/Header_2.vue";
import Endorsements from "@/components/landing/Endorsements.vue";
import SupportedProducts from "@/components/landing/SupportedProducts";

import DataMixin from "@/components/global/mixins/DataMixin";

export default {
  mixins: [DataMixin],
  components: {
    UnderLinedHeader,
    Header,
    Header_2,
    Services,
    Products,
    ScrollDownBtn,
    techSteps,
    //Carousel,
    Endorsements,
    SupportedProducts,
  },
};
</script>
 
